import "core-js/modules/es6.string.small";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import ChristmasSelection from '~/components/molecules/Editorial/Christmas/ChristmasSelection.vue';
export default {
  name: 'ChristmasPriceRange',
  components: {
    ChristmasSelection
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref11;

      return {
        mainBackground: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.main_background : _ref11 : _ref11) || '',
        selection: this.payload.items.map(i => {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

          return {
            url: new UrlParse(((_ref10 = i) != null ? (_ref10 = _ref10.url) != null ? _ref10.url : _ref10 : _ref10) || '').pathname,
            backgroundColor: ((_ref9 = i) != null ? _ref9.background_color : _ref9) || '',
            image: {
              small: formatPrismicImage((_ref8 = i) != null ? (_ref8 = _ref8.image) != null ? (_ref8 = _ref8.small) != null ? _ref8.url : _ref8 : _ref8 : _ref8) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref7 = i) != null ? (_ref7 = _ref7.image) != null ? (_ref7 = _ref7.large) != null ? _ref7.url : _ref7 : _ref7 : _ref7) || EMPTY_PIXEL
            },
            textColor: ((_ref6 = i) != null ? _ref6.text_color : _ref6) || '',
            title: ((_ref5 = i) != null ? (_ref5 = _ref5.title) != null ? _ref5[0] : _ref5 : _ref5) || {},
            description: ((_ref4 = i) != null ? _ref4.description : _ref4) || '',
            tracking: {
              data: {
                event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
              }
            }
          };
        })
      };
    }

  }
};